<template>
  <div>
    <AddAnnouncement v-model="dialogFormVisible"></AddAnnouncement>
    <div style="margin: 10px;float:left;">
      <el-button @click="dialogFormVisible=true" type="primary">新增公告</el-button>
      <FileUploader></FileUploader>
    </div>

    <EditableTable
        :data="data"
        :columnConfigs="columnConfigs"
        style="min-width: 900px;"
        @save="onSave"
        @delete="onDelete"
        height="84vh"
    ></EditableTable>
  </div>
</template>

<script>
import EditableTable from "@/components/EditableTable";
import FileUploader from "@/components/FileUploader";
import {announceDel, announceEdit, announceList, announceOrder} from "@/api";
import AddAnnouncement from '@/components/AddAnnouncement'

export default {
  name: "Info",
  components: {EditableTable, FileUploader, AddAnnouncement},
  data() {
    return {
      data: [],
      columnConfigs: [
        {name: 'AID', alias: '編號', editable: false, needLevel: 0, width: '5%'},
        {name: 'CODE', alias: '圖片編碼', editable: true, needLevel: 0, width: '10%'},
        {name: 'PIC', alias: '圖片', editable: false, needLevel: 0, width: '20%'},
        {name: 'LINK', alias: '連結', editable: true, needLevel: 0, width: '20%'},
        {name: 'SDATE', alias: '起始日', editable: true, needLevel: 0, width: '10%'},
        {name: 'EDATE', alias: '結束日', editable: true, needLevel: 0, width: '10%'},
        {name: 'ORDER', alias: '順序', editable: true, needLevel: 0, width: '10%'},
        {name: 'DELETE', alias: '功能', editable: true, needLevel: 0, width: '5%'},
      ],
      dialogFormVisible: false
    }
  },
  watch: {
    dialogFormVisible(newVal, oldVal) {
      if (!newVal) {
        this.getList()
      }
    }
  },
  methods: {
    orderList() {
      // make sure all number
      this.data.forEach(el => {
        el.AID *= 1
        el.ORDER *= 1
      })

      this.data.sort(function (a, b) {
        if (a.ORDER === b.ORDER) {
          return a.AID - b.AID
        } else {
          return b.ORDER - a.ORDER
        }
      })
    },
    onSave({columnName, data}) {
      const {AID, CODE, LINK, SDATE, EDATE, ORDER} = data
      data.edit.splice(data.edit.indexOf(columnName), 1)
      if (columnName === 'ORDER') {
        announceOrder({AID, ORDER})
            .then(res => {
              this.$message.success('公告順序修改成功')
              this.orderList()
            })
            .catch(e => {
              this.$message.error('公告順序修改失敗')
            })
      } else {
        announceEdit({AID, CODE, LINK, SDATE, EDATE})
            .then(res => {
              this.$message.success('公告修改成功')
            })
            .catch(e => {
              this.$message.error('公告修改失敗')
            })
      }
    },
    onDelete({columnName, data}) {
      const {AID} = data
      this.$confirm('此操作将永久删除该公告, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(res => {
            announceDel({AID})
                .then(res => {
                  const i = this.data.findIndex(el => el.AID === AID)
                  this.data.splice(i, 1)
                  this.$message.success("公告刪除成功")
                })
                .catch(e => {
                  this.$message.error("公告刪除失敗")
                })
          })
    },
    getList() {
      announceList()
          .then(({LIST}) => {
            LIST.forEach(item => {
              item.edit = []
              if (item.ORDER === undefined) {
                item.ORDER = 0
              }
            })

            this.data = LIST
            this.orderList()
          })
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped>

</style>
